// alternative-dashboard/alternative-components/compactWidgetsCardDetails/RepairQueueCard.tsx
import { useEffect, useState } from "react";
import { t } from "i18next";
import { gxDashboardPendingRepairCountApi } from "@/app/apiConfig/services/customerAbstractApiLayer";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";
import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";

interface RepairQueueCardProps {
  title?: string;
}

const RepairQueueCard = ({ title }: RepairQueueCardProps) => {
  const [repairCount, setRepairCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [currencyCode, setCurrencyCode] = useState("AED");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadRepairQueue = async () => {
      setLoading(true);

      try {
        const result = await gxDashboardPendingRepairCountApi({});

        if (!isMounted) return;

        const data = result?.data;

        setRepairCount(data?.countOfRepair ?? 0);
        setTotalAmount(data?.totalAmount ?? 0);
        setCurrencyCode(data?.currencyCode ?? "AED");
      } catch (error) {
        console.error("RepairQueueCard:", error);

        if (isMounted) {
          setRepairCount(0);
          setTotalAmount(0);
          setCurrencyCode("AED");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadRepairQueue();

    return () => {
      isMounted = false;
    };
  }, []);

  const formattedTotal = gxCurrencyFormat(
    totalAmount,
    currencyCode,
    undefined,
    {
      showSymbol: true,
      showCode: false,
    },
  );

  const hasMeaningfulDecimal =
    formattedTotal.decimal && formattedTotal.decimal !== ".00";

  return (
    <div className="gx-repair-queue-card">
      {loading && (
        <div className="gx-bene-form-container-loading-overlay">
          <SubmitLoading />
        </div>
      )}

      <h3 className="gx-repair-queue-card__title gx-p18-b">
        {title || t("repair_queue")}
      </h3>

      <span className="gx-repair-queue-card__count gx-p48-b">
        {repairCount}
      </span>

      <p className="gx-repair-queue-card__subtitle gx-p14-md">
        Transactions pending consent &middot; {formattedTotal.symbol}{" "}
        {formattedTotal.integer}
        {hasMeaningfulDecimal && formattedTotal.decimal} {t("total")}
      </p>
    </div>
  );
};

export default RepairQueueCard;
